import React, { useState, useEffect } from 'react';
import { reviews } from '../data';

export default function ReviewSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setVisibleCount(1);
      } else if (window.innerWidth < 1024) {
        setVisibleCount(2);
      } else {
        setVisibleCount(3);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % reviews.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  // Get the visible reviews based on responsive count
  const visibleReviews = [];
  for (let i = 0; i < visibleCount; i++) {
    const index = (currentIndex + i) % reviews.length;
    visibleReviews.push(reviews[index]);
  }

  return (
    <div className="relative w-full py-6">
      {/* Slider Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {visibleReviews.map((review, index) => (
          <div
            key={`${review.id}-${index}`}
            className="bg-white p-6 border border-slate-100 shadow-sm flex flex-col justify-between min-h-[240px] transition-all duration-300 rounded-none"
          >
            <div>
              <div className="flex items-center gap-1 text-amber-500 mb-3">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star text-sm" />
                ))}
              </div>
              {review.titel && (
                <h5 className="font-display font-bold text-slate-900 text-base mb-2">
                  {review.titel}
                </h5>
              )}
              <p className="text-slate-600 text-sm leading-relaxed italic mb-4">
                "{review.tekst}"
              </p>
            </div>
            <div className="border-t border-slate-100 pt-3 mt-auto">
              <h4 className="font-display font-semibold text-slate-900 text-sm uppercase tracking-wider">
                {review.navn}
              </h4>
              <p className="text-xs text-slate-500">
                {review.rolle}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <div className="flex justify-center items-center gap-4 mt-8">
        <button
          onClick={prevSlide}
          className="w-10 h-10 bg-brand-primary border border-brand-primary text-white hover:bg-brand-primary/90 transition-all flex items-center justify-center rounded-none cursor-pointer shadow-sm"
          aria-label="Forrige anmeldelse"
        >
          <i className="fa-solid fa-arrow-left" />
        </button>
        <span className="text-xs font-semibold uppercase tracking-widest text-slate-400">
          {currentIndex + 1} / {reviews.length}
        </span>
        <button
          onClick={nextSlide}
          className="w-10 h-10 bg-brand-primary border border-brand-primary text-white hover:bg-brand-primary/90 transition-all flex items-center justify-center rounded-none cursor-pointer shadow-sm"
          aria-label="Næste anmeldelse"
        >
          <i className="fa-solid fa-arrow-right" />
        </button>
      </div>
    </div>
  );
}
